import { Grid, Typography } from "@material-ui/core";
import { Layout, useQuery } from "@roc/feature-app-core";
import { Button, SelectField, StandardDialog } from "@roc/ui";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from "react-router";
import { useAppraisalsStore } from "../hooks";

const useStyles = makeStyles({
  '@global': {
    body: {
      backgroundColor: 'transparent !important',
    },
  },
  closeButtonContainer: {
    paddingTop: 16,
  },
  button: {
    width: '100%',
  },
});


const AppraisalReconsiderationContent = observer(({loanId}: any) => {
  const { appraisalsStore } = useAppraisalsStore()

  useEffect(() => {
    appraisalsStore.setSelectedLoanId(loanId);
    appraisalsStore.getPropertiesOptions();
  }, [loanId]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1">
          Please select the property for which you would like to request an appraisal recertification.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <SelectField
          label="Select Property"
          options={appraisalsStore.propertiesOptions}
          testId={'selectProperty'}
          value={appraisalsStore.selectedProperty}
          onChange={
            value => appraisalsStore.setSelectedProperty(value)
          }
          fullWidth
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
});

export const RequestAppraisalReconsiderationModal = observer(() => {
  const [openModal, setOpenModal] = useState(false);
  const classes = useStyles();
  const query = useQuery();
  const { loanId } = useParams<{ loanId: string }>();
  const { appraisalsStore } = useAppraisalsStore()

  useEffect(() => {
    if (query.get('openModal') === 'true') {
      setOpenModal(true);
      window.parent.postMessage({ action: 'modal-ready' }, '*');
    }
  }, [query]);

  const closeModal = () => {
    window.parent.postMessage({ action: 'close-modal' }, '*');
    setOpenModal(false);
  };

  return (
    <Layout maxWidth="lg">
      <Grid container spacing={2} style={{ width: '100%' }}>
        <StandardDialog
          title="Request Appraisal Recertification"
          open={openModal}
          onClose={closeModal}
          handleClose={closeModal}
          removeContentBox
          dialogContent={
            <AppraisalReconsiderationContent loanId={loanId} />
          }
          dialogActions={
            <Grid
              container
              spacing={2}
              xs={12}
              justifyContent="flex-end"
              className={classes.closeButtonContainer}
            >
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={closeModal}
                  testId="cancel"
                >
                  Close
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => { appraisalsStore.requestReconsideration() }}
                  testId="request-reconsideration"
                >
                  Request Reconsideration
                </Button>
              </Grid>
            </Grid>
          }
        ></StandardDialog>
      </Grid>
    </Layout>
  );
});
